import { createModule, constants } from "./redux-acron";
import api from "services/api";
import moment from "moment";
import { put, all } from "redux-saga/effects";
import {
  handlerWrapper,
  handlerWrapperSingleton,
  handlerEffects
} from "../utils";
import initialState from "../utils/initialState";

/**
 * Alerts Module
 * reducer/sagas/actions
 *
 * TODO: Agregar todos los handlers y effects para los diferentes indicadores
 */
export default createModule({
  name: "alerts",
  modelName: "alerts",
  formData: {},
  loadingFormData: false,

  state: {
    alertDashboard: {
      alertsByGeoLocation: [],
      alertsByLogicalLocation: [],
      details: []
    },
    alerts: [],
    loading: false,
    loadingData: {},
    filters: {}
  },

  // ------

  handlers: {
    setFilters: (state, { payload }) => {
      const newData = { data: [{ ...payload.filters }] };
      return state.merge({
        loading: true,
        filters: newData.data[0]
      });
    },
    clearErrors: state => {
      return state.merge({
        loading: false,
        error: []
      });
    },
    getAlerts: (state, { payload, status = constants.PENDING_STATUS }) => {
      const newPayload = payload;
      let alertTypes = [];
      if (payload.data) {
        payload.data.forEach(alert => {
          alert.createdAt = moment(alert.createdAt).format("DD/MM/YYYY HH:mm");
          if (alert.alertStatus && !alertTypes.includes(alert.alertStatus)) {
            alertTypes = alertTypes.concat(alert.alertStatus);
          }
        });
        if (newPayload.data[0]) {
          newPayload.data[0].alertTypes = alertTypes;
        }
      }
      return handlerWrapper("alerts", state, status, newPayload);
    },
    getAlertById: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (payload.data) {
        payload.data.createdAt = moment(payload.data.createdAt).format(
          "DD/MM/YYYY HH:mm"
        );
      }
      return handlerWrapper("currentAlert", state, status, payload);
    },
    getComments: (state, { payload, status = constants.PENDING_STATUS }) => {
      return handlerWrapper("comments", state, status, payload);
    },
    getFormData: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (status === constants.PENDING_STATUS) {
        return state.merge({
          loadingFormData: true,
          formData: {}
        });
      }

      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          loadingFormData: false,
          formData: payload
        });
      }
      return state;
    },
    changeStatus: (state, { payload, status = constants.PENDING_STATUS }) => {
      return handlerWrapper("status", state, status, payload);
    },
    getDashboardAlerts: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      let alertsByGeoLocationData = [[]];
      let alertsByLogicalLocationData = [[]];
      if (payload && payload.data) {
        payload.data.alertsByGeoLocation.forEach(alert => {
          if (!alert.counters) return;
          Object.values(alert.counters).forEach((counter, index) => {
            alertsByGeoLocationData[index] =
              alertsByGeoLocationData[index] || [];
            alertsByGeoLocationData[index] = alertsByGeoLocationData[
              index
            ].concat(counter);
          });
        });
        payload.data.alertsByLogicalLocation.forEach(alert => {
          if (!alert.counters) return;
          Object.values(alert.counters).forEach((counter, index) => {
            alertsByLogicalLocationData[index] =
              alertsByLogicalLocationData[index] || [];
            alertsByLogicalLocationData[index] = alertsByLogicalLocationData[
              index
            ].concat(counter);
          });
        });
        if (payload.data.alertsByGeoLocation[0]) {
          payload.data.alertsByGeoLocation[0].dataSet = alertsByGeoLocationData;
        }
        if (payload.data.alertsByLogicalLocation[0]) {
          payload.data.alertsByLogicalLocation[0].dataSet = alertsByLogicalLocationData;
        }
      }
      return handlerWrapper("alertDashboard", state, status, payload);
    }
  },

  effects: {
    // Get alerts indicator
    getDashboardAlerts: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.alertsIndicators.dashboard,
          payload.filters,
          actions.getDashboardAlerts
        );
      }
    },
    getFormData: {
      *callback(actions) {
        // const [
        //   customerStatus,
        //   claimTypes,
        //   serviceStatus,
        //   failSpecs,
        //   actionsRes,
        //   problemTypes
        // ] = yield all([
        //   api.resolutions.getCustomerStatus(),
        //   api.resolutions.getClaimTypes(),
        //   api.resolutions.getServiceStatus(),
        //   api.resolutions.getFailSpecs(),
        //   api.resolutions.getActions(),
        //   api.resolutions.getProblemTypes()
        // ]);
        // yield put(
        //   actions.getFormData(
        //     {
        //       customerStatus: customerStatus.data,
        //       claimTypes: claimTypes.data,
        //       serviceStatus: serviceStatus.data,
        //       failSpecs: failSpecs.data,
        //       actionsRes: actionsRes.data,
        //       problemTpyes: problemTypes.data
        //     },
        //     constants.SUCCESS_STATUS
        //   )
        // );
      }
    },
    getAlerts: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.alertsIndicators.alerts,
          payload.filters,
          actions.getAlerts
        );
      }
    },
    getAlertById: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.alertsIndicators.alertById,
          payload,
          actions.getAlertById
        );
      }
    },
    getComments: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.alertsIndicators.comments,
          payload,
          actions.getComments
        );
      }
    },
    changeStatus: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.alertsIndicators.changeStatus,
          payload,
          actions.changeStatus
        );
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/AlertsModule.js